import styled from 'styled-components';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import { LANDING_IMAGES } from '../landingAssets';
import LandingArrow from './LandingArrow';

const LandingPartnerTypesStyled = styled.section``;

const PARTNER_CARDS = [
    ['webmasters', LANDING_IMAGES.icon01],
    ['influencers', LANDING_IMAGES.icon02],
    ['signals', LANDING_IMAGES.icon03],
    ['schools', LANDING_IMAGES.icon04],
    ['strategies', LANDING_IMAGES.icon05],
];

function LandingPartnerTypes({ onOpenContact }) {
    const { getLangPath } = useLangContext();

    const openFromKeyboard = (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        onOpenContact();
    };

    return (
        <LandingPartnerTypesStyled className="hero wrap partner-types" id="partner-types">
            <div className="partner-section-head">
                <div className="kicker">{getLangPath('landing.partners.kicker')}</div>
                <h2>
                    {getLangPath('landing.partners.titleLine1')}
                    <br className="partner-heading-break"/>
                    {' '}
                    {getLangPath('landing.partners.titleLine2')}
                </h2>
            </div>
            <div className="partner-grid">
                {PARTNER_CARDS.map(([key, icon]) => (
                    <article className="partner-card" key={key}>
                        <div className="partner-icon" aria-hidden="true">
                            <img src={icon} alt="" width="36" height="36"/>
                        </div>
                        <h3>{getLangPath(`landing.partners.${key}Title`)}</h3>
                        <p>{getLangPath(`landing.partners.${key}Text`)}</p>
                    </article>
                ))}
                <article
                    className="partner-card partner-invite"
                    role="button"
                    tabIndex={0}
                    aria-haspopup="dialog"
                    aria-label={getLangPath('landing.partners.nicheAria')}
                    onClick={onOpenContact}
                    onKeyDown={openFromKeyboard}
                >
                    <div className="partner-icon" aria-hidden="true">
                        <img src={LANDING_IMAGES.icon06} alt="" width="36" height="36"/>
                    </div>
                    <h3>{getLangPath('landing.partners.nicheTitle')}</h3>
                    <span className="niche-arrow" aria-hidden="true">
                        <LandingArrow/>
                    </span>
                    <p>{getLangPath('landing.partners.nicheText')}</p>
                </article>
            </div>
        </LandingPartnerTypesStyled>
    );
}

export default LandingPartnerTypes;
